import * as React from 'react';

import { clampBubble, setBubbleInitialState } from './helpers';

interface IUseBubbleClampArgs {
  maxHeight: number;
  expandButtonClassName: string;
  textClassName: string;
}

export const useBubbleClamp = ({ maxHeight, expandButtonClassName, textClassName }: IUseBubbleClampArgs) => {
  const rootRef = React.useRef<HTMLDivElement | null>(null);

  const [isCollapsed, setIsCollapsed] = React.useState(true);
  const isFirstEffectRef = React.useRef(true);

  React.useEffect(() => {
    const rootElement = rootRef.current;

    if (!rootElement || !isFirstEffectRef.current) {
      return;
    }

    if (!isCollapsed) {
      return setBubbleInitialState(rootElement, textClassName);
    }

    // обеспечиваем единственное выполнение эффекта
    isFirstEffectRef.current = false;

    clampBubble(rootElement, maxHeight, setIsCollapsed, expandButtonClassName, textClassName);
  }, [expandButtonClassName, isCollapsed, maxHeight, textClassName]);

  const onExpandButtonClick = React.useCallback(() => {
    setIsCollapsed(false);
    isFirstEffectRef.current = true;
  }, []);

  return { rootRef, onExpandButtonClick, isCollapsed };
};
